'use client';

import { Box, Grid, Typography, Paper } from '@mui/material';
import Image from 'next/image';
import { Link } from '@/i18n/routing';
import { useTranslations } from 'next-intl';

const LOCATION_IMAGES = ['/images/osaka.jpeg', '/images/okushima.jpg', '/images/cambodia_office.jpg'];
const LOCATION_HREFS = ['https://www.spacianet.co.jp', '#', '#'];

const OfficeLocations = () => {
    const t = useTranslations('AboutPage.office_locations');

    const locations = [
        {
            title: t('loc_0_title'),
            address: [t('loc_0_address_0'), t('loc_0_address_1'), t('loc_0_address_2')],
            image: LOCATION_IMAGES[0],
            href: LOCATION_HREFS[0],
        },
        {
            title: t('loc_1_title'),
            address: [t('loc_1_address_0'), t('loc_1_address_1'), t('loc_1_address_2')],
            image: LOCATION_IMAGES[1],
            href: LOCATION_HREFS[1],
        },
        {
            title: t('loc_2_title'),
            address: [t('loc_2_address_0'), t('loc_2_address_1')],
            image: LOCATION_IMAGES[2],
            href: LOCATION_HREFS[2],
        },
    ];

    return (
        <Box sx={{ py: 6 }}>
            <Typography variant="h4" component="h2" sx={{ fontWeight: 800, color: '#132c4b', textAlign: 'center', mb: 8 }}>
                {t('title')}
            </Typography>
            <Grid container spacing={4}>
                {locations.map((loc, index) => (
                    <Grid size={{ xs: 12, sm: 4, md: 4 }} key={index}>
                        <Link href={loc.href}>
                            <Paper
                                elevation={0}
                                sx={{
                                    p: 4,
                                    height: '100%',
                                    borderRadius: '16px',
                                    border: '1px solid #e2e8f0',
                                    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05)',
                                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                    cursor: 'pointer',
                                    '&:hover': {
                                        transform: 'translateY(-8px)',
                                        boxShadow: '0 12px 24px -4px rgba(0, 0, 0, 0.15)',
                                        borderColor: '#F15859',
                                    }
                                }}
                            >
                                <Typography variant="h6" sx={{ fontWeight: 800, color: '#1e293b', mb: 3 }}>
                                    {loc.title}
                                </Typography>
                                {loc.address.map((line, i) => (
                                    <Typography key={i} variant="body2" sx={{ color: '#475569', mb: 0.5, lineHeight: 1.6 }}>
                                        {line}
                                    </Typography>
                                ))}
                                <Image width={400} height={300} src={loc.image} alt={loc.title} className='w-full aspect-[4/3] object-cover rounded-lg mt-6' />
                            </Paper>
                        </Link>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};

export default OfficeLocations;
